import React from "react"
import Menu_IconAdd from "../../components/molecules/icon-add";

type Props = {
    className?  : string

    name        : string

    onClick     : func
}

export default function NavigationMenuAdd(props:Props) {
    return (
        <div className={Classes('item', props.className)} onClick={props.onClick}>
            <div className="row">
                <div className="flex-row-between-center w-100-percent">
                    <div className="flex-row-left-center">
                        <Menu_IconAdd />
                        <div className="name">{props.name}</div>
                    </div>

                    {/*<div className="item-popover-arrow ui5-ico-12 i5-angle-right"/>*/}
                </div>
            </div>
        </div>
    )
}
